import { render, staticRenderFns } from "./yi-pay-order.vue?vue&type=template&id=728ea9cf&scoped=true&"
import script from "./yi-pay-order.vue?vue&type=script&lang=js&"
export * from "./yi-pay-order.vue?vue&type=script&lang=js&"
import style0 from "./yi-pay-order.vue?vue&type=style&index=0&id=728ea9cf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728ea9cf",
  null
  
)

component.options.__file = "src/components/yi-pay-order/yi-pay-order.vue"
export default component.exports